import * as React from "react";
import { Button, Chip, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CreateCaseDialog from "../../../components/dialogs/createCase";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import * as actions from "../../../store/cases/actions";
import { Tag } from "src/api/classes";
import FilterView from "../../../components/filter";
import { DubitoSvc } from "src/api";
import _ from "lodash";
import { openSnack } from "src/util/util";
interface Props {
  tags: Tag[];
  selected: number[];
  fetchTags: () => void;
  case_id: number;
  readOnly?: boolean;
  onUpdated: () => void;
}
interface State {}
class CaseTags extends React.Component<Props, State> {
  state = {
    showNewCase: false,
    selectedTags: this.props.selected,
    edit: false
  };
  componentWillMount() {
    if (this.props.tags && this.props.selected) {
      this.prepare(this.props.selected, this.props.tags);
    } else {
      this.props.fetchTags();
    }
  }
  componentWillReceiveProps(next) {
    if (next.tags && next.selected) {
      this.prepare(next.selected, next.tags);
    }
  }
  edit = () => {
    const selected = this.state.selectedTags.map((i: any) => i.value);

    const deletedTags = _.uniq(_.difference(this.props.selected, selected));
    const insertedTags = _.uniq(_.difference(selected, this.props.selected));

    DubitoSvc.editCaseTags({
      case_id: this.props.case_id,
      deletedTags,
      insertedTags
    })
      .then(() => {
        this.setState({ edit: false });
        this.props.onUpdated();
        openSnack("Case Updated!", "success");
      })
      .catch(() => {
        openSnack("Case Update Failed!", "error");
      });
  };
  prepare(tags: number[], allTags: Tag[]) {
    const selectedTags = tags.map(t => {
      const c = allTags.find(a => a.id === t);
      if (c) {
        return {
          label: c.title,
          value: c.id
        };
      }
    });
    this.setState({ selectedTags });
  }
  render() {
    if (!this.props.tags) {
      return null;
    }
    const tags =
      this.props.tags &&
      this.props.tags.map(c => ({
        label: c.title,
        value: c.id
      }));
    if (this.state.edit) {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FilterView
            theme
            values={this.state.selectedTags}
            suggestions={tags}
            title="Tags"
            placeholder="Afrin, Diyanet"
            onChange={(values: any[]) => {
              //console.log(values);
              this.setState({ selectedTags: values });
            }}
          />
          <Button color="primary" onClick={this.edit}>
            Save
          </Button>
          <Button
            onClick={() => {
              this.prepare(this.props.selected, this.props.tags);
              this.setState({ edit: false });
            }}
          >
            Cancel
          </Button>
        </div>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          alignItems: "row",
          marginTop: 16,
          marginBottom: 8
        }}
      >
        {this.props.selected &&
          this.props.selected.length === 0 &&
          !this.props.readOnly && (
            <Chip
              style={{ opacity: 0.3 }}
              onClick={() => {
                this.setState({ edit: true });
              }}
              label={"ADD TAG"}
            />
          )}
        {this.props.selected &&
          this.state.selectedTags.map((t: any, i) => {
            if (t) {
              return !this.props.readOnly ? (
                <Tooltip key={i} title="Click to edit" placement="right">
                  <Chip
                    onClick={() => this.setState({ edit: true })}
                    style={{ marginRight: 4 }}
                    label={t.label}
                  />
                </Tooltip>
              ) : (
                <Chip style={{ marginRight: 4 }} label={t.label} />
              );
            }
          })}
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {
    tags: state.cases.tags
  };
}
function mapDispatchToProps(dispatch) {
  return { fetchTags: (): any => dispatch(actions.fetchTags()) };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseTags);



// WEBPACK FOOTER //
// ./src/pages/cases/components/caseTags.tsx